import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit linear garden piece: like a wall it runs along the X axis
// through the tile centre, exactly one tile (1 m) long, so consecutive
// hedge tiles chain into a continuous clipped run.
const LEAF = "#5f8f4e";
const LEAF_DARK = "#4e7a3e";

export const gardenHedge = defineModel({
  id: "garden-hedge",
  batchId: "modern",
  name: "Garden hedge",
  tags: ["modern", "outdoor", "garden", "hedge", "plant"],
  summary: "A clipped box hedge segment, one tile long.",
  description:
    "A straight clipped hedge of the Modern Living kit: 1 m long along X, " +
    "0.35 m thick, 0.7 m high, with a darker clipped top. Chain tiles for " +
    "longer runs; rotate 90 degrees to orient.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.64, 0.35), color: LEAF, position: [0, 0.32, 0] },
      // Slightly wider, darker top slab — the freshly clipped crown.
      {
        geometry: new THREE.BoxGeometry(1.0, 0.06, 0.37),
        color: LEAF_DARK,
        position: [0, 0.67, 0],
      },
    ];
  },
  animations: [],
});
